'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionFilterService', function (SearchModel, TransactionsModel) {
    var self = this;

    self.all = function () {
      return true;
    };

    self.needsReceipt = function (transaction) { //
      return _.get(transaction, 'receiptIds', []).length === 0;
    };

    self.notReviewed = function (transaction) { //
      return transaction.mutableTransactionProperties.transactionStatus === 'NOT_REVIEWED';
    };

    self.needsSubmission = function (transaction) { //
      return !_.get(transaction, 'mutableTransactionProperties.cardmemberSubmitted', false);
    };

    self.needsCardManagerApproval = function (transaction) { //
      return !_.get(transaction, 'mutableTransactionProperties.cardManagerApproved', false);
    };

    self.needsBcaManagerApproval = function (transaction) { //
      return !_.get(transaction, 'mutableTransactionProperties.bcaManagerApproved', false);
    };

    self.needsAccountingManagerApproval = function (transaction) {
      return !_.get(transaction, 'mutableTransactionProperties.accountingManagerApproved', false);
    };

    self.unlinked = function (transaction) {
      return !transaction.transactionThirdPartyData || transaction.transactionThirdPartyData.length == 0;
    };

    self.notExtracted = function (transaction) {
      return _.get(transaction, 'lockStatus', 'UNLOCKED') === 'UNLOCKED';
    };

    self.searchResults = function (transaction) {
      if (TransactionsModel.transactionCount() < TransactionsModel.maxTransactions()) {
        return _.includes(SearchModel.results(), transaction.id);
      } else {
        return true;
      }
    };

    self.filterTransactions = function (filterName, transactions) {
      var func = _.get(self, filterName);

      if (!func) {
        return [];
      }

      return _.filter(transactions, func);
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/TransactionFilterService.js
// module id = 649
// module chunks = 0